// extracted by mini-css-extract-plugin
export var brands = "collabs-module--brands--87368";
export var brandsInner = "collabs-module--brandsInner--8f75e";
export var carousel = "collabs-module--carousel--857c5";
export var content = "collabs-module--content--6aa67";
export var videoInfo = "collabs-module--videoInfo--e483b";